import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

const SchrittmacherMRTPage = () => {
  return (
    <Layout>
      <PageHero
        title="Schrittmacher-MRT-Koordination"
        subtitle="Sichere Planung und fachärztliche Abstimmung bei MRT-Untersuchungen mit Herzschrittmacher."
        backgroundImage="/images/Herzschrittmacher.webp"
        ctaText="Beratung vereinbaren"
      />

      <ContentSection
        title="Individuelle Prüfung und Abstimmung"
        content="In enger Zusammenarbeit mit Kardiologie und Radiologie prüfen wir, ob und unter welchen Voraussetzungen eine MRT-Untersuchung möglich ist. Die Sicherheit unserer Patientinnen und Patienten steht dabei immer an erster Stelle."
        image="/images/Herzschrittmacher.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Koordinierte Versorgung im Medicum Diez"
        content="Bei Patientinnen und Patienten mit Herzschrittmacher oder implantierbarem Defibrillator (ICD) ist eine MRT-Untersuchung nicht ohne weiteres möglich. Wir koordinieren die notwendigen Abklärungen und Vorbereitungen zwischen den beteiligten Fachärzten."
        image="/images/MRT 5.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <SEOContent
        title="MRT bei Herzschrittmacher Diez"
        content="Koordination von MRT-Untersuchungen bei Herzschrittmachern im Medicum Diez in enger fachärztlicher Abstimmung zwischen Kardiologie und Radiologie."
      />

      <CTASection
        title="Beratung vereinbaren"
        subtitle="Vereinbaren Sie Ihren Beratungstermin zur Schrittmacher-MRT-Koordination online oder telefonisch."
        buttonText="Kontakt aufnehmen"
      />
    </Layout>
  );
};

export default SchrittmacherMRTPage;
